__webpack_require__.p = "/shopping-cart-react/";